import { RewardType } from '~/shared';

const REWARD_TYPE_LABELS: Record<RewardType, string> = {
	[RewardType.MONEY]: 'Деньги',
	[RewardType.EXP]: 'Опыт',
	[RewardType.ITEM]: 'Предмет',
	[RewardType.VEHICLE]: 'Транспорт',
	[RewardType.LOOTBOX]: 'Кейс',
	[RewardType.BUNDLE]: 'Набор',
	[RewardType.VEHICLE_TUNING_KIT]: 'Набор тюнинга',
	[RewardType.VEHICLE_TUNING_ITEM]: 'Элемент тюнинга',
};

const REWARD_TYPE_OPTIONS = Object.values(RewardType).map((type) => ({
	value: type,
	label: REWARD_TYPE_LABELS[type],
}));

const getRewardLabel = (type: RewardType): string => {
	switch (type) {
		case RewardType.MONEY:
			return 'Сумма (Руб.)';
		case RewardType.EXP:
			return 'Количество XP';
		case RewardType.ITEM:
			return 'ID предмета';
		case RewardType.VEHICLE:
			return 'Модель ТС';
		case RewardType.LOOTBOX:
			return 'ID кейса';
		case RewardType.BUNDLE:
			return 'ID набора';
		case RewardType.VEHICLE_TUNING_KIT:
			return 'ID набора тюнинга';
		case RewardType.VEHICLE_TUNING_ITEM:
			return 'ID элемента тюнинга';
	}
};

const getRewardPlaceholder = (type: RewardType): string => {
	switch (type) {
		case RewardType.MONEY:
			return '1 000 000';
		case RewardType.EXP:
			return '1 000';
		case RewardType.ITEM:
			return 'item_id';
		case RewardType.VEHICLE_TUNING_KIT:
			return 'kit_id';
		case RewardType.VEHICLE_TUNING_ITEM:
			return 'item_id';
		default:
			return '';
	}
};

const getSelectPlaceholder = (type: RewardType): string => {
	switch (type) {
		case RewardType.VEHICLE:
			return 'Выберите транспорт...';
		case RewardType.LOOTBOX:
			return 'Выберите кейс...';
		case RewardType.BUNDLE:
			return 'Выберите набор...';
		case RewardType.ITEM:
			return 'Выберите предмет...';
		case RewardType.VEHICLE_TUNING_KIT:
			return 'Выберите кит тюнинга...';
		case RewardType.VEHICLE_TUNING_ITEM:
			return 'Выберите деталь тюнинга...';
		default:
			return '';
	}
};

const getFilterPlaceholder = (type: RewardType): string => {
	switch (type) {
		case RewardType.VEHICLE:
			return 'Поиск транспорта...';
		case RewardType.LOOTBOX:
			return 'Поиск кейса...';
		case RewardType.BUNDLE:
			return 'Поиск набора...';
		case RewardType.ITEM:
			return 'Поиск предмета...';
		case RewardType.VEHICLE_TUNING_KIT:
			return 'Поиск кита тюнинга...';
		case RewardType.VEHICLE_TUNING_ITEM:
			return 'Поиск детали тюнинга...';
		default:
			return '';
	}
};

const isSearchableType = (type: RewardType): boolean =>
	[
		RewardType.VEHICLE,
		RewardType.LOOTBOX,
		RewardType.BUNDLE,
		RewardType.ITEM,
		RewardType.VEHICLE_TUNING_KIT,
		RewardType.VEHICLE_TUNING_ITEM,
	].includes(type);

export {
	getFilterPlaceholder,
	getRewardLabel,
	getRewardPlaceholder,
	getSelectPlaceholder,
	isSearchableType,
	REWARD_TYPE_OPTIONS,
};
